export default __webpack_public_path__ + "static/reviews-hover-ca79e0b3814207f6b21103b09713526d.webp";